/*
 * Mother's Day 2026 — Product Page
 * ============================================================================
 * Phase 1: 4-stage staged countdown, synced across 3 surfaces:
 *   - .mdp-announcement       (announcement bar — hides in Stage 4)
 *   - .mdp-countdown-chip     (price chip, added in Phase 2 — hides in Stage 4)
 *   - [data-mdp-trust-middle] (trust strip middle, added in Phase 3 — shows
 *                              evergreen copy in Stage 4)
 *
 * Stages:
 *   1 — before free_ship_deadline        (Stage-1 copy in all 3 places)
 *   2 — between deadline and cutoff      (Stage-2 copy)
 *   3 — between cutoff and Mother's Day  (Stage-3 copy)
 *   4 — after Mother's Day               (evergreen)
 *
 * All date configuration lives on the root element .mday2026-product as
 * data attributes (rendered from theme customizer settings by the Liquid
 * section). No hard-coded dates here.
 */
(function () {
  'use strict';

  var ROOT_SEL = '.mday2026-product';

  function parseDate(str) {
    // YYYY-MM-DD → midnight UTC end-of-day in Eastern Time (-04:00 DST).
    // Matches the Liquid section's convention.
    if (!str) return null;
    var d = new Date(str + 'T23:59:59-04:00');
    return isNaN(d.getTime()) ? null : d;
  }

  function computeStage(now, freeShipDeadline, standardCutoff, mothersDay) {
    if (mothersDay && now > mothersDay) return 4;
    if (standardCutoff && now > standardCutoff) return 3;
    if (freeShipDeadline && now > freeShipDeadline) return 2;
    return 1;
  }

  function stageTarget(stage, freeShipDeadline, standardCutoff, mothersDay) {
    if (stage === 1) return freeShipDeadline;
    if (stage === 2) return standardCutoff;
    if (stage === 3) return mothersDay;
    return null;
  }

  function diffParts(targetMs, nowMs) {
    var ms = Math.max(0, targetMs - nowMs);
    var totalSec = Math.floor(ms / 1000);
    var days = Math.floor(totalSec / 86400);
    var hrs = Math.floor((totalSec % 86400) / 3600);
    var mins = Math.floor((totalSec % 3600) / 60);
    var secs = totalSec % 60;
    return { days: days, hrs: hrs, mins: mins, secs: secs };
  }

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function setDigit(el, value) {
    if (!el) return;
    var str = pad(value);
    if (el.textContent !== str) el.textContent = str;
  }

  function updateDigits(scope, parts) {
    setDigit(scope.querySelector('[data-mdp-days]'), parts.days);
    setDigit(scope.querySelector('[data-mdp-hrs]'),  parts.hrs);
    setDigit(scope.querySelector('[data-mdp-mins]'), parts.mins);
    setDigit(scope.querySelector('[data-mdp-secs]'), parts.secs);
  }

  function applyStage(root, stage) {
    // Announcement bar: hidden in Stage 4
    root.querySelectorAll('.mdp-announcement').forEach(function (el) {
      if (stage === 4) el.setAttribute('hidden', '');
      else el.removeAttribute('hidden');
    });

    // Countdown chip: hidden in Stage 4; otherwise show stage-matching copy
    root.querySelectorAll('.mdp-countdown-chip').forEach(function (el) {
      if (stage === 4) {
        el.setAttribute('hidden', '');
        return;
      }
      el.removeAttribute('hidden');
      el.querySelectorAll('[data-stage]').forEach(function (copy) {
        var s = parseInt(copy.getAttribute('data-stage'), 10);
        copy.hidden = s !== stage;
      });
    });

    // Trust strip middle column: always visible; swap copy per stage.
    // Scoped to document (not just root) because the evergreen trust strip
    // section lives OUTSIDE the .mday2026-product wrapper.
    document.querySelectorAll('[data-mdp-trust-middle]').forEach(function (el) {
      el.querySelectorAll('[data-stage]').forEach(function (copy) {
        var s = parseInt(copy.getAttribute('data-stage'), 10);
        copy.hidden = s !== stage;
      });
    });

    root.setAttribute('data-mdp-stage', String(stage));
  }

  function tick(root, state) {
    var now = new Date();
    var stage = computeStage(now, state.deadline, state.cutoff, state.mday);

    if (stage !== state.lastStage) {
      applyStage(root, stage);
      state.lastStage = stage;
    }

    if (stage === 4) {
      // No digits to tick; disarm timer when done
      if (state.interval) {
        clearInterval(state.interval);
        state.interval = null;
      }
      return;
    }

    var target = stageTarget(stage, state.deadline, state.cutoff, state.mday);
    if (!target) return;
    var parts = diffParts(target.getTime(), now.getTime());

    root.querySelectorAll('[data-mdp-digits]').forEach(function (scope) {
      updateDigits(scope, parts);
    });

    // Also update "X days" text nodes in chip/trust copy
    root.querySelectorAll('[data-mdp-days-text]').forEach(function (el) {
      if (el.textContent !== String(parts.days)) {
        el.textContent = String(parts.days);
      }
    });
  }

  function init(root) {
    if (!root || root.dataset.mdpInit === '1') return;
    root.dataset.mdpInit = '1';

    // Dormant page (holiday outside the lead window): the countdown DOM is not
    // rendered, so there is nothing to tick. No-op cleanly.
    if (root.getAttribute('data-mdp-dormant') === '1') return;

    var state = {
      deadline: parseDate(root.getAttribute('data-free-ship-deadline')),
      cutoff:   parseDate(root.getAttribute('data-standard-cutoff')),
      mday:     parseDate(root.getAttribute('data-mothers-day')),
      lastStage: null,
      interval: null
    };

    tick(root, state);
    state.interval = setInterval(function () { tick(root, state); }, 1000);
  }

  function boot() {
    document.querySelectorAll(ROOT_SEL).forEach(init);
    document.querySelectorAll(ROOT_SEL).forEach(initImages);
    document.querySelectorAll(ROOT_SEL).forEach(initVariants);
    document.querySelectorAll(ROOT_SEL).forEach(initReserve);
    document.querySelectorAll(ROOT_SEL).forEach(initCardPicker);
    document.querySelectorAll(ROOT_SEL).forEach(initStickyAtc);
    // Phase 3B components live in their own sections (outside .mday2026-product),
    // so they initialize at document scope
    initTabs(document);
    initFAQ(document);
    // Nudge Shopify Inbox chat button up so it doesn't stack on top of the
    // sticky ATC + Google widget + Klaviyo popup (all right-bottom anchored).
    liftShopifyInbox();
  }

  // Force Shopify Inbox to the right side and higher up the viewport so it
  // doesn't clash with the sticky ATC, Google widget, or Klaviyo popup.
  // Uses the unique SVG path as a DOM fingerprint → walks up to the
  // fixed-positioned ancestor → overrides position. Applies on both load
  // and resize (in case the app reapplies its own position). Does not
  // touch any other widget.
  function liftShopifyInbox() {
    var attempts = 0;
    function applyPosition(el) {
      var isMobile = window.matchMedia('(max-width: 640px)').matches;
      el.style.setProperty('bottom', isMobile ? '240px' : '200px', 'important');
      el.style.setProperty('right', isMobile ? '4px' : '16px', 'important');
      el.style.setProperty('left', 'auto', 'important');
      el.style.setProperty('top', 'auto', 'important');
      el.style.setProperty('z-index', '2147483641', 'important');
      el.style.setProperty('display', 'block', 'important');
      el.style.setProperty('visibility', 'visible', 'important');
      el.style.setProperty('opacity', '1', 'important');
    }
    function tryLift() {
      attempts++;
      // Prefer the known Shopify Inbox custom element, fall back to SVG-path
      // fingerprint for older builds.
      var el = document.querySelector('inbox-online-store-chat#ShopifyChat')
        || document.querySelector('inbox-online-store-chat')
        || document.querySelector('#ShopifyChat');
      if (!el) {
        var path = document.querySelector('path[d*="M4 9.78374"]');
        if (path) {
          el = path;
          while (el && getComputedStyle(el).position !== 'fixed') el = el.parentElement;
        }
      }
      if (!el) {
        if (attempts < 25) setTimeout(tryLift, 500);
        return;
      }
      applyPosition(el);
      // The app might re-apply its own position styles after its own init.
      // Keep a watcher that re-forces our position for ~15 seconds.
      var reapplyCount = 0;
      var reapply = setInterval(function () {
        reapplyCount++;
        applyPosition(el);
        if (reapplyCount > 30) clearInterval(reapply);
      }, 500);
      window.addEventListener('resize', function () { applyPosition(el); });
    }
    tryLift();
  }

  // =========================================================================
  // Phase 4 — Sticky ATC: slides up when main ATC scrolls out of view.
  // IntersectionObserver watches the main [data-mdp-atc] button.
  // Clicking the sticky button dispatches a click on the main submit button
  // so the form fires with all hidden inputs (variant id, quantity,
  // properties[_Ship Preference], properties[_Card Style]) intact.
  // =========================================================================
  function initStickyAtc(root) {
    var stickyBar = root.querySelector('[data-mdp-sticky-atc]');
    var mainAtc = root.querySelector('[data-mdp-atc]');
    if (!stickyBar || !mainAtc) return;
    if (!('IntersectionObserver' in window)) return;

    var stickyBtn = stickyBar.querySelector('[data-mdp-sticky-atc-btn]');

    // Click: forward to the main form's submit button so validation +
    // line item properties fire exactly the same as the main ATC flow.
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (mainAtc.disabled) return;
        mainAtc.click();
      });
    }

    // Gate the sticky bar on user engagement. On a fresh landing where the
    // customer hasn't scrolled at all, we don't want the bar popping up —
    // it feels pushy and they haven't even explored yet. Once they've
    // scrolled or clicked a Giftship category (which triggers an auto-scroll
    // from occasion-dated-multi-add-fix.js), we treat it as engagement and let
    // the bar appear normally whenever the main ATC is out of view.
    var hasEngaged = false;
    window.addEventListener('scroll', function () { hasEngaged = true; }, { once: true, passive: true });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var shouldShow = hasEngaged && !entry.isIntersecting;
        stickyBar.classList.toggle('is-visible', shouldShow);
        stickyBar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
        document.body.classList.toggle('mdp-sticky-atc-visible', shouldShow);
      });
    }, { rootMargin: '0px', threshold: 0 });

    // Delay observation start by 800ms so initial layout shifts settle
    // before the observer's first fire.
    setTimeout(function () { observer.observe(mainAtc); }, 800);
  }

  // =========================================================================
  // Phase 3B — Tabs (tablist / tab / tabpanel pattern + keyboard nav)
  // =========================================================================
  function initTabs(scope) {
    scope.querySelectorAll('.mdp-tabs').forEach(function (root) {
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-mdp-tab]'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('[role="tabpanel"]'));
      if (tabs.length === 0) return;

      function activate(index) {
        if (index < 0 || index >= tabs.length) return;
        tabs.forEach(function (t, i) {
          var active = i === index;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
          t.setAttribute('tabindex', active ? '0' : '-1');
        });
        panels.forEach(function (p, i) {
          var active = i === index;
          p.classList.toggle('is-active', active);
          if (active) p.removeAttribute('hidden');
          else p.setAttribute('hidden', '');
        });
      }

      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () { activate(index); });
        tab.addEventListener('keydown', function (e) {
          var key = e.key;
          if (key === 'ArrowRight' || key === 'ArrowDown') {
            e.preventDefault();
            var next = (index + 1) % tabs.length;
            activate(next);
            tabs[next].focus();
          } else if (key === 'ArrowLeft' || key === 'ArrowUp') {
            e.preventDefault();
            var prev = (index - 1 + tabs.length) % tabs.length;
            activate(prev);
            tabs[prev].focus();
          } else if (key === 'Home') {
            e.preventDefault();
            activate(0);
            tabs[0].focus();
          } else if (key === 'End') {
            e.preventDefault();
            activate(tabs.length - 1);
            tabs[tabs.length - 1].focus();
          }
        });
      });
    });
  }

  // =========================================================================
  // Phase 3B — FAQ accordion (click/Enter/Space toggles answer)
  // =========================================================================
  function initFAQ(scope) {
    scope.querySelectorAll('.mdp-faq [data-mdp-faq-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        var controls = btn.getAttribute('aria-controls');
        var panel = controls ? document.getElementById(controls) : null;
        if (panel) {
          if (expanded) panel.setAttribute('hidden', '');
          else panel.removeAttribute('hidden');
        }
      });
    });
  }

  // =========================================================================
  // Phase 2B — Reserve Now expand/collapse + radio → hidden _Ship Preference
  //          — also hides the section after reserve_hide_date
  // =========================================================================
  function initReserve(root) {
    var MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

    function shortDate(ymd) {
      var p = (ymd || '').split('-');
      if (p.length !== 3) return '';
      var m = parseInt(p[1], 10), d = parseInt(p[2], 10);
      if (!m || !d) return '';
      return MONTHS[m - 1] + ' ' + d;
    }
    function longDate(ymd) {
      var p = (ymd || '').split('-');
      if (p.length !== 3) return '';
      var y = parseInt(p[0], 10), m = parseInt(p[1], 10), d = parseInt(p[2], 10);
      if (!y || !m || !d) return '';
      return MONTHS[m - 1] + ' ' + d + ', ' + y;
    }

    root.querySelectorAll('[data-mdp-reserve]').forEach(function (reserve) {
      var dateMode = reserve.hasAttribute('data-customer-date');

      // Auto-hide after the hide-date (skipped in date mode — birthday never hides)
      if (!dateMode) {
        var hideDateStr = reserve.getAttribute('data-hide-date');
        if (hideDateStr) {
          var hideDate = parseDate(hideDateStr);
          if (hideDate && new Date() > hideDate) {
            reserve.hidden = true;
            var pastInput = reserve.querySelector('[data-mdp-ship-pref-input]');
            if (pastInput) pastInput.value = '';
            return;
          }
        }
      }

      // Expand / collapse (no-op in date mode: panel renders open, no toggle)
      var toggle = reserve.querySelector('[data-mdp-reserve-toggle]');
      var panelId = toggle ? toggle.getAttribute('aria-controls') : null;
      var panel = panelId ? document.getElementById(panelId) : null;
      if (toggle && panel) {
        toggle.addEventListener('click', function () {
          var isOpen = toggle.getAttribute('aria-expanded') === 'true';
          toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
          panel.hidden = isOpen;
        });
      }

      var hiddenInput = reserve.querySelector('[data-mdp-ship-pref-input]');
      var sticker = reserve.querySelector('[data-mdp-sticker]');

      function syncSticker() {
        if (!dateMode || !sticker) return;
        var asap = reserve.querySelector('[data-mdp-ship-pref][value="asap"]');
        sticker.hidden = !(asap && asap.checked);
      }

      // Radio -> hidden _Ship Preference (+ sticker visibility in date mode)
      reserve.querySelectorAll('[data-mdp-ship-pref]').forEach(function (radio) {
        radio.addEventListener('change', function () {
          if (hiddenInput && radio.checked) {
            hiddenInput.value = radio.getAttribute('data-ship-pref-label') || radio.value;
          }
          syncSticker();
        });
      });

      // Optional customer date -> hidden Do Not Open Until property + live sticker
      if (dateMode) {
        var visible = reserve.querySelector('[data-mdp-dnod-visible]');
        var dnod = reserve.querySelector('[data-mdp-dnod-input]');
        var stickerDate = reserve.querySelector('[data-mdp-sticker-date]');
        var fallback = stickerDate ? (stickerDate.getAttribute('data-fallback') || '') : '';

        function syncDate() {
          var ymd = visible ? visible.value : '';
          var sd = shortDate(ymd);
          if (ymd && sd) {
            if (dnod) { dnod.value = longDate(ymd); dnod.disabled = false; }
            if (stickerDate) stickerDate.textContent = sd;
          } else {
            if (dnod) { dnod.value = ''; dnod.disabled = true; }
            if (stickerDate) stickerDate.textContent = fallback;
          }
        }

        if (visible) {
          visible.addEventListener('change', syncDate);
          visible.addEventListener('input', syncDate);
        }
        syncDate();
      }

      syncSticker();
    });
  }

  // =========================================================================
  // Phase 2B — Card picker — radio click updates is-selected state,
  //            label, and hidden _Card Style input
  // =========================================================================
  function initCardPicker(root) {
    root.querySelectorAll('[data-mdp-card-picker]').forEach(function (picker) {
      var hiddenInput = picker.querySelector('[data-mdp-card-input]');
      var nameLabel = picker.querySelector('[data-mdp-card-name]');
      var radios = picker.querySelectorAll('[data-mdp-card-radio]');

      // Sync initial state from the default-checked radio
      var initialChecked = Array.prototype.find.call(radios, function (r) { return r.checked; });
      if (initialChecked) {
        if (hiddenInput) hiddenInput.value = initialChecked.value;
        if (nameLabel) nameLabel.textContent = initialChecked.value;
      }

      radios.forEach(function (radio) {
        radio.addEventListener('change', function () {
          if (!radio.checked) return;
          picker.querySelectorAll('.mdp-card-picker__card').forEach(function (card) {
            card.classList.remove('is-selected');
          });
          var card = radio.closest('.mdp-card-picker__card');
          if (card) card.classList.add('is-selected');
          if (hiddenInput) hiddenInput.value = radio.value;
          if (nameLabel) nameLabel.textContent = radio.value;
        });
      });
    });
  }

  // =========================================================================
  // Phase 2A — thumbnail click → swap main image
  // =========================================================================
  function initImages(root) {
    var mainWrap = root.querySelector('[data-mdp-main-image]');
    if (!mainWrap) return;
    var mainImg = mainWrap.querySelector('img');

    root.querySelectorAll('[data-mdp-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var fullSrc = btn.getAttribute('data-mdp-full-src');
        var alt = btn.getAttribute('data-mdp-alt') || '';
        if (!fullSrc || !mainImg) return;
        mainImg.src = fullSrc;
        mainImg.srcset = '';
        mainImg.alt = alt;

        root.querySelectorAll('.mdp-product-thumb').forEach(function (li) {
          li.classList.remove('is-active');
        });
        var li = btn.closest('.mdp-product-thumb');
        if (li) li.classList.add('is-active');
      });
    });
  }

  // =========================================================================
  // Phase 2A — variant switching
  //   - Listens to all .mdp-variant-select changes
  //   - Reads the product.variants JSON
  //   - Matches selected option values to a variant
  //   - Updates hidden id, price, ATC availability, and image (if variant has one)
  // =========================================================================
  function formatMoneyCents(cents) {
    // Simple CAD fallback formatter; Shopify.formatMoney is not guaranteed here.
    var amount = (Math.round(cents) / 100).toFixed(2);
    return '$' + amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function initVariants(root) {
    var dataEl = root.querySelector('[data-mdp-variants]');
    if (!dataEl) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); }
    catch (e) { return; }
    if (!Array.isArray(variants) || variants.length === 0) return;

    var selects = root.querySelectorAll('.mdp-variant-select');
    var hiddenId = root.querySelector('[data-mdp-variant-id]');
    var priceCurrent = root.querySelector('.mdp-price__current');
    var priceCompare = root.querySelector('.mdp-price__compare');
    var pricePill = root.querySelector('.mdp-price__pill');
    var atc = root.querySelector('[data-mdp-atc]');
    var atcLabel = atc ? atc.querySelector('.mdp-atc__label') : null;
    var atcPrice = atc ? atc.querySelector('.mdp-atc__price') : null;
    var mainImg = root.querySelector('[data-mdp-main-image] img');

    function findVariant() {
      var chosen = Array.prototype.map.call(selects, function (sel) { return sel.value; });
      return variants.find(function (v) {
        if (!v) return false;
        var opts = [v.option1, v.option2, v.option3];
        for (var i = 0; i < chosen.length; i++) {
          if (opts[i] !== chosen[i]) return false;
        }
        return true;
      });
    }

    function applyVariant(v) {
      if (!v) return;
      if (hiddenId) hiddenId.value = v.id;

      // Price
      if (priceCurrent) {
        priceCurrent.textContent = formatMoneyCents(v.price);
        priceCurrent.classList.toggle('mdp-price__current--sale',
          v.compare_at_price && v.compare_at_price > v.price);
      }
      if (priceCompare) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          priceCompare.textContent = formatMoneyCents(v.compare_at_price);
          priceCompare.style.display = '';
        } else {
          priceCompare.style.display = 'none';
        }
      }
      if (pricePill) {
        pricePill.style.display = (v.compare_at_price && v.compare_at_price > v.price) ? '' : 'none';
      }

      // ATC availability
      if (atc) {
        if (v.available) {
          atc.disabled = false;
          atc.classList.remove('mdp-atc--sold-out');
          if (atcLabel) atcLabel.textContent = atc.getAttribute('data-atc-text') || 'Add to Cart';
          if (atcPrice) { atcPrice.textContent = formatMoneyCents(v.price); atcPrice.style.display = ''; }
        } else {
          atc.disabled = true;
          atc.classList.add('mdp-atc--sold-out');
          if (atcLabel) atcLabel.textContent = atc.getAttribute('data-sold-text') || 'Sold Out';
          if (atcPrice) atcPrice.style.display = 'none';
        }
      }

      // Swap image if variant has its own
      if (v.featured_image && v.featured_image.src && mainImg) {
        mainImg.src = v.featured_image.src;
        mainImg.srcset = '';
        mainImg.alt = v.featured_image.alt || mainImg.alt;
      }

      // Reflect in URL without reloading (so Shop Pay + share links carry the variant)
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) { /* ignore */ }
    }

    // Stash current ATC labels before any swap
    if (atc && atcLabel) {
      if (!atc.getAttribute('data-atc-text')) atc.setAttribute('data-atc-text', atcLabel.textContent.trim());
    }

    selects.forEach(function (sel) {
      sel.addEventListener('change', function () {
        applyVariant(findVariant());
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
